import appConfig from '@/config';

export const OPEN_DATA_PARTNER_AB_TEST_THRESHOLD = 51615;

export function isOrgInAbTestGroup(orgId: number, threshold: number): boolean {
  return orgId <= threshold || orgId % 3 === 0;
}

export function isOrgInSmartOnboardingTestGroup(orgId: number): boolean {
  if (appConfig.env !== 'prod') return true;
  return orgId % 3 === 0;
}

/**
 * 50:50 A/B test of the partnership requests pop-up on My Partners: even org
 * ids see it. Remove with the pop-up's check once the test concludes.
 * @see https://crossbeam.slack.com/archives/C04ENUE0P0E/p1793638619024319 (2026-11-02)
 */
export function isOrgInPartnerRequestsModalTestGroup(orgId: number): boolean {
  if (appConfig.env !== 'prod') return true;
  return orgId % 2 === 0;
}
